/* eslint-disable */
import {axios} from "~/plugins/axios";

const getDefaultState_GraphQl = () => {
  return {
    allProjects: [],
    projects: [],
    users: [],
    allGroups: [],
    groups: [],
    allContracts: [],
    contracts: [],
  }
}
const state = getDefaultState_GraphQl();

const getters = {
  allProjects: state => state.allProjects,
  projects: state => state.projects,
  users: state => state.users,
  allGroups: state => state.allGroups,
  groups: state => state.groups,
  allContracts: state => state.allContracts,
  contracts: state => state.contracts,
}

const actions = {
  async loadAllProjects({commit}) {
    const res = await axios.post('/api/graphql', {query: `{projects {id name}}`})
      .catch(error => {
        console.error(error);
      })

    commit('SET_ALL_PROJECTS', res.data.data.projects);
    return res.data.data.projects
  },

  async loadProjects({commit}, payload) {
    const res = await axios.post('/api/graphql', payload)
      .catch(error => {
        console.error(error);
      })

    commit('SET_PROJECTS', res.data.data.projects);
    return res.data.data.projects
  },

  async loadAllContracts({commit}) {
    const res = await axios.post('/api/graphql', {query: `{Contracts {data {id number} } }`})
      .catch(error => {
        console.error(error);
      })

    commit('SET_ALL_CONTRACTS', res.data.data.Contracts.data);
    return res.data.data.Contracts.data
  },

  async loadContracts({commit}, payload) {
    const res = await axios.post('/api/graphql', payload)
      .catch(error => {
        console.error(error);
      })

    commit('SET_CONTRACTS', res.data.data.Contracts.data);
    return res.data.data.Contracts.data
  },

  async loadUsers({commit}, payload) {
    const res = await axios.post('/api/graphql', payload)
      .catch(error => {
        console.error(error);
      })

    commit('SET_USERS', res.data.data.users);
    return res.data.data.users;
  },

  async loadAllGroups({commit}) {
    const res = await axios.post('/api/graphql', {query: `{groups {id name}}`})
      .catch(error => {
        console.error(error);
      })

    commit('SET_ALL_GROUPS', res.data.data.groups);
    return res.data.data.groups;
  },

  async loadGroups({commit}, fields) {
    const res = await axios.post('/api/graphql', {
      query: `{groups {${fields}}}`
    })
      .catch(error => {
        console.error(error);
      })

    commit('SET_GROUPS', res.data.data.groups);
    return res.data.data.groups
  },

  async loadGraph({commit}, query) {
    const res = await axios.post('/api/graphql', {
      query: `{${query}}`
    })
      .catch(error => {
        console.error(error);
      })

    return res.data.data
  },



}

const mutations = {
  SET_ALL_PROJECTS(state, data) {
    state.allProjects = data;
  },

  SET_PROJECTS(state, data) {
    state.projects = data;
  },

  SET_ALL_CONTRACTS(state, data) {
    state.allContracts = data;
  },

  SET_CONTRACTS(state, data) {
    state.contracts = data;
  },

  SET_USERS(state, data) {
    state.users = data;
  },

  SET_ALL_GROUPS(state, data) {
    state.allGroups = data;
  },

  SET_GROUPS(state, data) {
    state.groups = data;
  },


  RESET_STATE_GRAPHQL(state) {
    Object.assign(state, getDefaultState_GraphQl())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
